export default __webpack_public_path__ + "static/spiritual-maya-activity-3-d47e03d8f3536338df85ea6aaa40789f.jpg";